import React from "react";
import { TouchableOpacity, Text, StyleSheet } from "react-native";

import * as Colors from "../styles/colors"
import * as Fonts from "../styles/typography";

export default function Button({ textoBotao, estilo, onPress, estiloText }) {
    return <TouchableOpacity onPress={onPress} style={[estilos.botao, estilo]}>
        <Text style={[estilos.estiloTexto, estiloText]}>
            {textoBotao}
        </Text>
    </TouchableOpacity>
}

const estilos = StyleSheet.create({

    botao: {
        // backgroundColor: Colors.PRIMARY,
        borderRadius: 8,
        alignItems: "center",
        paddingVertical: 8,
        paddingHorizontal: 8,
        justifyContent: "center",
        backgroundColor: Colors.PRIMARY,
    },
    estiloTexto: {
        color: Colors.TEXTOBOTAO,
        fontSize: Fonts.FONT_SIZE_18,
        letterSpacing: 1,
        lineHeight: Fonts.LINE_HEIGHT_28,
        fontWeight: "bold"
    },

})
